import {
  ICreateUserBody,
  ICreateUserResponse,
  IUpload,
} from "../../utils/types";
import { apiManager } from "../api-manager";

export const createUser = async ({
  fullName,
  email,
  password,
  repeat_password,
  phone,
  profileImage,
  state,
}: ICreateUserBody) => {
  const fd = new FormData();
  let res;
  let res2;

  fd.append("file", profileImage);
  fd.append("type", "profilePhoto");
  fd.append("userType", "user");
  fd.append("email", email);
  res2 = await apiManager.post<IUpload>("/upload", fd);

  let file;
  if (res2.success) {
    file = res2?.data?.Location;
  }

  res = await apiManager.post<ICreateUserResponse>("/admin/user/create", {
    fullName,
    email,
    password,
    repeat_password,
    phone,
    profileImage: file,
    state,
    selectedAccountType: "individual",
  });
  return res;
};
